import React, { useEffect, useState } from 'react';
import './Home.css';

const Home = () => {
  const [scrollY, setScrollY] = useState(0);
  const [activeBenefit, setActiveBenefit] = useState('');
  const [currentPage, setCurrentPage] = useState(0);

  // Shorter testimonials data for compact display
  const testimonials = [
    {
      id: 1,
      name: "Dr. Rajesh Kumar",
      title: "Orthopedic Surgeon",
      specialization: "Foot & Ankle Specialist",
      experience: "25+ Years",
      type: "ortho",
      initials: "RK",
      quote: "I-Revive represents a groundbreaking advancement in foot health technology. The integration of EMS and TENS addresses multiple therapeutic mechanisms simultaneously."
    },
    {
      id: 2,
      name: "Dr. Sarah Thompson",
      title: "Senior Physiotherapist",
      specialization: "Sports & Rehab Medicine",
      experience: "18+ Years",
      type: "physio",
      initials: "ST",
      quote: "The clinical efficacy is remarkable. I've observed significant improvements in patient recovery times, particularly in post-surgical rehabilitation cases."
    },
    {
      id: 3,
      name: "Dr. Michael Chen",
      title: "Orthopedic Physician",
      specialization: "Biomechanics & Gait Analysis",
      experience: "20+ Years",
      type: "ortho",
      initials: "MC",
      quote: "From a biomechanical perspective, I-Revive addresses root causes of foot dysfunction through targeted muscle stimulation and proprioception enhancement."
    },
    {
      id: 4,
      name: "Dr. Amanda Lee",
      title: "Lead Physiotherapist",
      specialization: "Vascular & Lymphatic Therapy",
      experience: "15+ Years",
      type: "physio",
      initials: "AL",
      quote: "The vascular benefits are extraordinary. I've documented measurable improvements in venous return and lymphatic drainage in challenging clinical cases."
    },
    {
      id: 5,
      name: "Dr. James Singh",
      title: "Orthopedic Surgeon",
      specialization: "Diabetic Foot Care",
      experience: "22+ Years",
      type: "ortho",
      initials: "JS",
      quote: "For diabetic patients, I-Revive offers unprecedented neuroprotective benefits. The controlled stimulation enhances nerve function and promotes healing."
    },
    {
      id: 6,
      name: "Dr. Rachel Norton",
      title: "Senior Physiotherapist",
      specialization: "Geriatric Rehabilitation",
      experience: "16+ Years",
      type: "physio",
      initials: "RN",
      quote: "In elderly care, I-Revive has proven invaluable for fall prevention. The muscle strengthening significantly reduces fall risk and enhances quality of life."
    }
  ];

  const testimonialsPerPage = 3;
  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    
    // Benefits section background change functionality
    const benefitItems = document.querySelectorAll('.benefit-item');
    const benefitsSection = document.querySelector('.benefits');
    
    const observerOptions = {
      threshold: 0.3,
      rootMargin: '-30% 0px -30% 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bgType = entry.target.getAttribute('data-bg');
          setActiveBenefit(bgType);
          if (benefitsSection) {
            benefitsSection.setAttribute('data-active', bgType);
          }
        }
      });
    }, observerOptions);

    benefitItems.forEach(item => {
      observer.observe(item);
      item.style.cursor = 'default';
    });

    // Keyboard navigation for testimonials
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        setCurrentPage(prev => prev > 0 ? prev - 1 : prev);
      } else if (e.key === 'ArrowRight') {
        setCurrentPage(prev => prev < totalPages - 1 ? prev + 1 : prev);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('keydown', handleKeyDown);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('keydown', handleKeyDown);
      observer.disconnect();
    };
  }, [totalPages]);

  const nextPage = () => {
    setCurrentPage(prev => prev < totalPages - 1 ? prev + 1 : prev);
  };

  const prevPage = () => {
    setCurrentPage(prev => prev > 0 ? prev - 1 : prev);
  };

  const goToPage = (pageIndex) => {
    setCurrentPage(pageIndex);
  };

  const getCurrentTestimonials = () => {
    const startIndex = currentPage * testimonialsPerPage;
    return testimonials.slice(startIndex, startIndex + testimonialsPerPage);
  };

  return (
    <div className="home">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
          <a href="/" className="logo-link">
            <span className="logo-text">I-Revive</span>
          </a>
         </div>
          <div className="nav-menu">
            <a href="/" className="nav-link active">Home</a>
            <a href="/about" className="nav-link">About</a>
            <a href="#product" className="nav-link">Product</a>
            <a href="#benefits" className="nav-link">Benefits</a>
            <a href="#technology" className="nav-link">Technology</a>
            <a href="/contact" className="nav-link">Contact</a>
          </div>
          <div className="nav-cta">
            <a href="#preorder" className="btn btn-primary">Pre-Order</a>
          </div>
        </div>
      </nav>

      {/* Full Width Hero Section */}
      <section className="hero" id="home">
        <div className="hero-full-width">
          <div className="hero-content-wrapper">
            <div className="hero-text-section">
              <h1 className="hero-title fade-in-up">
                Meet <span className="highlight">I-Revive</span>
              </h1>
              <p className="hero-subtitle fade-in-up">
                Enhance Mobility, Accelerate Recovery
              </p>
              <p className="hero-description fade-in-up">
                World's first footwear with built-in EMS and TENS technology that works on your 100+ foot muscles
              </p>
              <div className="hero-buttons fade-in-up">
                <a href="#preorder" className="btn btn-primary">Pre-Order Now</a>
                <a href="/about" className="btn btn-secondary">Learn More</a>
              </div>
            </div>
            
            <div className="hero-image-section">
              <div className="hero-product-showcase">
                <img src="/images/1.jpeg" alt="I-Revive Smart Slippers" className="hero-main-product" />
                <div className="hero-glow-effect"></div>
                <div className="hero-floating-elements">
                  <div className="floating-dot dot-1"></div>
                  <div className="floating-dot dot-2"></div>
                  <div className="floating-dot dot-3"></div>
                  <div className="floating-dot dot-4"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Gallery */}
      <section className="product-gallery" id="gallery">
        <div className="container">
          <div className="section-header">
            <h2>See I-Revive in Action</h2>
            <p>Experience the world's first smart recovery footwear with built-in EMS and TENS technology</p>
          </div>
          
          <div className="gallery-grid">
            <div className="gallery-item main-item">
              <div className="gallery-icon main-icon">
                <div className="icon-wrapper">
                  <div className="foot-icon">
                    <div className="foot-shape"></div>
                    <div className="pulse-ring"></div>
                    <div className="energy-waves">
                      <div className="wave wave-1"></div>
                      <div className="wave wave-2"></div>
                      <div className="wave wave-3"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gallery-content">
                <h3>Slip Into Better Foot Health</h3>
                <p>Pre-order your I-Revive slippers today</p>
              </div>
            </div>
            
            <div className="gallery-item">
              <div className="gallery-icon">
                <div className="components-icon">
                  <div className="slipper-base"></div>
                  <div className="detachable-sole"></div>
                  <div className="connection-points">
                    <div className="point point-1"></div>
                    <div className="point point-2"></div>
                    <div className="point point-3"></div>
                  </div>
                </div>
              </div>
              <div className="gallery-content">
                <h4>Complete Package</h4>
                <p>Slippers with detachable sole system</p>
              </div>
            </div>
            
            <div className="gallery-item">
              <div className="gallery-icon">
                <div className="design-icon">
                  <div className="premium-slipper">
                    <div className="slipper-outline"></div>
                    <div className="comfort-lines">
                      <div className="line line-1"></div>
                      <div className="line line-2"></div>
                      <div className="line line-3"></div>
                    </div>
                    <div className="premium-badge"></div>
                  </div>
                </div>
              </div>
              <div className="gallery-content">
                <h4>Sleek Design</h4>
                <p>Premium black ergonomic slippers</p>
              </div>
            </div>
            
            <div className="gallery-item">
              <div className="gallery-icon">
                <div className="circulation-icon">
                  <div className="heart-pump">
                    <div className="heart-shape"></div>
                    <div className="flow-lines">
                      <div className="flow-line flow-line-1"></div>
                      <div className="flow-line flow-line-2"></div>
                      <div className="flow-line flow-line-3"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gallery-content">
                <h4>Blood Flow Enhancement</h4>
                <p>Improved circulation and reduced swelling</p>
              </div>
            </div>
            
            <div className="gallery-item">
              <div className="gallery-icon">
                <div className="muscle-recovery-icon">
                  <div className="muscle-fiber">
                    <div className="fiber-base"></div>
                    <div className="recovery-waves">
                      <div className="recovery-wave wave-1"></div>
                      <div className="recovery-wave wave-2"></div>
                      <div className="recovery-wave wave-3"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gallery-content">
                <h4>Muscle Recovery</h4>
                <p>EMS technology activates foot muscles</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits" id="benefits">
        <div className="container">
          <div className="benefits-content">
            <div className="benefits-text">
              <h2>Transform Your Recovery</h2>
              <div className="benefit-list">
                <div className="benefit-item" data-bg="workout">
                  <div className="benefit-content">
                    <h4>Post-Workout Muscle Recovery</h4>
                    <p>Accelerate healing and reduce soreness after intense activities</p>
                  </div>
                  <div className="benefit-photo">
                    <img src="/images/1.jpeg" alt="Advanced EMS Technology" />
                    <div className="photo-overlay">Advanced EMS Technology</div>
                  </div>
                </div>
                
                <div className="benefit-item" data-bg="travel">
                  <div className="benefit-content">
                    <h4>Travel Wellness & DVT Prevention</h4>
                    <p>Combat leg fatigue and swelling during long flights or commutes</p>
                  </div>
                  <div className="benefit-photo">
                    <img src="/images/6.png" alt="TENS Therapy" />
                    <div className="photo-overlay">TENS Therapy</div>
                  </div>
                </div>
                
                <div className="benefit-item" data-bg="injury">
                  <div className="benefit-content">
                    <h4>Injury Prevention & Posture Correction</h4>
                    <p>Strengthen foot muscles and improve overall stability</p>
                  </div>
                  <div className="benefit-photo">
                    <img src="/images/11.jpeg" alt="Advanced Components" />
                    <div className="photo-overlay">Advanced Components</div>
                  </div>
                </div>
                
                <div className="benefit-item" data-bg="gait">
                  <div className="benefit-content">
                    <h4>Gait Improvement</h4>
                    <p>Enhance walking efficiency and reduce fall risk</p>
                  </div>
                  <div className="benefit-photo">
                    <img src="/images/7.png" alt="Gait Analysis" />
                    <div className="photo-overlay">Gait Analysis</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Dynamic Background Overlays */}
        <div className="benefits-bg-overlay workout-bg"></div>
        <div className="benefits-bg-overlay travel-bg"></div>
        <div className="benefits-bg-overlay injury-bg"></div>
        <div className="benefits-bg-overlay gait-bg"></div>
      </section>

      {/* Compact Medical Testimonials Section */}
      <section className="medical-testimonials" id="testimonials">
        <div className="container">
          <div className="testimonials-header">
            <h2>Validated by Medical Professionals</h2>
            <p>Clinically validated and endorsed by leading orthopedic physicians and physiotherapists</p>
            
            <div className="validation-badges">
              <div className="validation-badge">
                <span className="icon">👨‍⚕️</span>
                <span>5 Orthopedic Physicians</span>
              </div>
              <div className="validation-badge">
                <span className="icon">🏥</span>
                <span>15 Physiotherapists</span>
              </div>
              <div className="validation-badge">
                <span className="icon">✅</span>
                <span>FDA Cleared (510K)</span>
              </div>
            </div>
          </div>
          
          <div className="testimonials-grid">
            {getCurrentTestimonials().map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-header">
                  <div className={`doctor-avatar ${testimonial.type}`}>
                    {testimonial.initials}
                  </div>
                  <div className="doctor-info">
                    <h4>{testimonial.name}</h4>
                    <div className="doctor-title">{testimonial.title}</div>
                    <div className="specialization">{testimonial.specialization}</div>
                  </div>
                </div>
                <div className="testimonial-quote">
                  <div className="quote-icon">"</div>
                  <p className="testimonial-text">
                    {testimonial.quote}
                  </p>
                </div>
                <div className="testimonial-footer">
                  <span className="experience-badge">{testimonial.experience}</span>
                  <div className="rating">
                    <span className="star">★</span>
                    <span className="star">★</span>
                    <span className="star">★</span>
                    <span className="star">★</span>
                    <span className="star">★</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="testimonials-navigation">
            <button 
              className="nav-arrow" 
              onClick={prevPage}
              disabled={currentPage === 0}
            >
              ←
            </button>
            
            <div className="testimonials-indicators">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  className={`page-indicator ${index === currentPage ? 'active' : ''}`}
                  onClick={() => goToPage(index)}
                />
              ))}
            </div>
            
            <button 
              className="nav-arrow" 
              onClick={nextPage}
              disabled={currentPage === totalPages - 1}
            >
              →
            </button>
          </div>
        </div>

        {/* Animated background elements */}
        <div className="testimonials-bg-elements">
          <div className="bg-element element-1"></div>
          <div className="bg-element element-2"></div>
          <div className="bg-element element-3"></div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="technology" id="technology">
        <div className="container">
          <div className="tech-header">
            <h2>Cutting-Edge Technology</h2>
            <p>FDA-approved EMS + TENS integration for optimal foot health</p>
          </div>
          
          <div className="tech-grid">
            <div className="tech-card">
              <div className="tech-icon ems"></div>
              <h3>EMS Technology</h3>
              <p>Electrical Muscle Stimulation activates foot muscles, reducing fatigue and improving strength</p>
              <div className="tech-specs">
                <span>10-22Hz pulses</span>
                <span>320μs</span>
              </div>
            </div>
            
            <div className="tech-card">
              <div className="tech-icon tens"></div>
              <h3>TENS Technology</h3>
              <p>Transcutaneous Electrical Nerve Stimulation enhances blood flow and relieves pain</p>
              <div className="tech-specs">
                <span>20-100Hz pulses</span>
                <span>120μs</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="target-audience">
        <div className="container">
          <h2>Perfect For Everyone</h2>
        </div>
        
        <div className="audience-container">
          <div className="audience-grid">
            <div className="audience-card">
              <div className="audience-photo">
                <img src="/images/13.png" alt="Desk Worker with back pain" />
              </div>
              <div className="audience-content">
                <span className="audience-badge">Desk Workers</span>
                <h3>By mid-day, my legs go numb</h3>
                <p className="audience-quote">73% report leg fatigue from sitting 6-8+ hours daily</p>
                <div className="audience-highlight">
                  Enhanced circulation during work
                </div>
              </div>
            </div>
            
            <div className="audience-card">
              <div className="audience-photo">
                <img src="/images/14.png" alt="Female athlete stretching" />
              </div>
              <div className="audience-content">
                <span className="audience-badge">Athletes</span>
                <h3>Resting slows my recovery</h3>
                <p className="audience-quote">Active stimulation improves healing by 30%</p>
                <div className="audience-highlight">
                  Accelerated muscle recovery
                </div>
              </div>
            </div>
            
            <div className="audience-card">
              <div className="audience-photo">
                <img src="/images/16.png" alt="Traveler with luggage" />
              </div>
              <div className="audience-content">
                <span className="audience-badge">Travelers</span>
                <h3>My feet swell up every flight</h3>
                <p className="audience-quote">60% of air travelers report foot swelling</p>
                <div className="audience-highlight">
                  DVT prevention & comfort
                </div>
              </div>
            </div>
            
            <div className="audience-card">
              <div className="audience-photo">
                <img src="/images/15.png" alt="Elderly couple exercising" />
              </div>
              <div className="audience-content">
                <span className="audience-badge">Elderly</span>
                <h3>My feet take ages to recover</h3>
                <p className="audience-quote">Falls are the leading cause of injury-related death</p>
                <div className="audience-highlight">
                  Improved stability & strength
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" id="preorder">
        <div className="container">
          <div className="cta-content">
            <h2>Pre-Order Your I-Revive Today</h2>
            <p>Join the revolution in smart recovery footwear. Limited early bird pricing available.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-secondary">Contact Us</a>
            </div>
          </div>
        </div>
      </section>

      {/* Simplified Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>I-Revive</h3>
              <p className="tagline">Enhance Mobility, Accelerate Recovery</p>
              <p className="description">Revolutionary footwear technology that enhances mobility, accelerates recovery, and transforms foot health through advanced EMS and TENS integration.</p>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <span className="icon">✉</span>
                  <span>vivek@craftmystrength.com</span>
                </div>
                <div className="footer-contact-item">
                  <span className="icon">🌐</span>
                  <span>www.CraftMyStrength.com</span>
                </div>
                <div className="footer-contact-item">
                  <span className="icon">📍</span>
                  <span>Hong Kong & India</span>
                </div>
              </div>
            </div>
            
            <div className="footer-col">
              <h4>Product</h4>
              <a href="/about">About</a>
              <a href="/home">Product</a>
              <a href="/about">About Us</a>
            </div>
            
            <div className="footer-col">
              <h4>Support</h4>
              <a href="/contact">Contact Us</a>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; <span className="year">2025</span> CraftMyStrength. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;